// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1__b3bca102928eb16d2e7d{/*!*/}.AuthorHeader-cls2___ef381fd2b6e5b9445b1{overflow-y:auto;padding:12px 16px;padding:var(--spacing-xs-12, 12px) var(--spacing-xs-16, 16px);min-width:400px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1__b3bca102928eb16d2e7d",
	"cls2": "AuthorHeader-cls2___ef381fd2b6e5b9445b1 AuthorHeader-cls1__b3bca102928eb16d2e7d"
};
export default ___CSS_LOADER_EXPORT___;
